import TableLayout from "@/components/layouts/page/TableLayout";
import {BorderArticle} from "@/components/ui/general/BorderArticle";

import React from "react";

import {H3} from "@ui/titles/H3";
import {useTranslation} from "react-i18next";

import {useEffectivenessContext} from "./EffectivenessContext";
import styles from "./styles.module.scss";

export const Analysis = () => {
  const {t} = useTranslation();
  const {
    currencySymbol,
    scenarioValues,
    formatInteger,
    formatDecimal,
    formatPaybackPeriod,
  } = useEffectivenessContext();

  const formatMetric = (metricKey) => {
    if (metricKey === "benefit") {
      return <strong>{t("page.effectiveness.metric.benefit")}</strong>;
    }

    if (metricKey === "roi") {
      return (
        <span className={styles.roiValue}>
          {t("page.effectiveness.metric.roi")}
        </span>
      );
    }

    return t(`page.effectiveness.metric.${metricKey}`);
  };

  const formatValue = (value, metricKey) => {
    if (metricKey === "roi") {
      return <span className={styles.roiValue}>{`${value}%`}</span>;
    }

    if (metricKey === "benefit") {
      return <strong>{`${currencySymbol}${value}`}</strong>;
    }

    if (metricKey === "investment" || metricKey === "benefits") {
      return `${currencySymbol}${value}`;
    }

    if (metricKey === "months") {
      return formatPaybackPeriod(value);
    }

    return value;
  };

  const analysisColumns = [
    {
      Header: t("table.metric"),
      accessor: "metricKey",
      width: 380,
      Cell: ({value}) => formatMetric(value),
    },
    {
      Header: t("table.conservative"),
      accessor: "conservative",
      width: 300,
      Cell: ({value, row}) => formatValue(value, row.original.metricKey),
    },
    {
      Header: t("table.revised"),
      accessor: "revised",
      width: 300,
      Cell: ({value, row}) => formatValue(value, row.original.metricKey),
    },
    {
      Header: t("table.optimistic"),
      accessor: "optimistic",
      width: 300,
      Cell: ({value, row}) => formatValue(value, row.original.metricKey),
    },
  ];

  const analysisData = [
    {
      metricKey: "investment",
      conservative: formatInteger(scenarioValues.conservative.investment),
      revised: formatInteger(scenarioValues.revised.investment),
      optimistic: formatInteger(scenarioValues.optimistic.investment),
    },
    {
      metricKey: "benefits",
      conservative: formatInteger(scenarioValues.conservative.benefits),
      revised: formatInteger(scenarioValues.revised.benefits),
      optimistic: formatInteger(scenarioValues.optimistic.benefits),
    },
    {
      metricKey: "benefit",
      conservative: formatInteger(scenarioValues.conservative.benefit),
      revised: formatInteger(scenarioValues.revised.benefit),
      optimistic: formatInteger(scenarioValues.optimistic.benefit),
    },
    {
      metricKey: "roi",
      conservative: formatDecimal(scenarioValues.conservative.roi),
      revised: formatDecimal(scenarioValues.revised.roi),
      optimistic: formatDecimal(scenarioValues.optimistic.roi),
    },
    {
      metricKey: "months",
      conservative: scenarioValues.conservative.months,
      revised: scenarioValues.revised.months,
      optimistic: scenarioValues.optimistic.months,
    },
  ];

  return (
    <BorderArticle>
      <H3>{t("page.effectiveness.analysis_title")}</H3>

      <hr />

      <div className={styles.effectiveness_analysis}>
        <TableLayout
          pagination={false}
          settings={false}
          search={false}
          serverStatus={"success"}
          columns={analysisColumns}
          data={analysisData}
          dataSize={5}
          totalPages={1}
          currentPage={1}
          toPage={() => {}}
          minHeight={380}
        />
      </div>
    </BorderArticle>
  );
};
